import * as React from 'react';
import PropTypes from 'prop-types';
import '../../styles/payment.css';

const propTypes = {
  productData: PropTypes.object,
  id: PropTypes.string,
};
const defaultProps = {
  productData: {
    siteId: '',
    sitePwd: '',
    productId: '',
    price: '',
    name: '',
    plan: '',
    day: '',
  },
  id: '',
};

export function PaymentTerm({ productData, id }) {
  const { siteId, price, name, productId, sitePwd } = productData;

  return (
    <div className={'term-list-item'}>
      <form
        name="pay"
        method="post"
        action="https://payment.alpha-note.co.jp/service/credit"
      >
        <input type="hidden" name="SiteId" value={siteId} />
        <input type="hidden" name="SitePass" value={sitePwd} />
        <input type="hidden" name="Amount" value={price} />
        <input type="hidden" name="itemId" value={productId} />
        <input type="hidden" name="language" value="ja" />
        <input type="hidden" name="CustomerId" value={id} />
        <input type="submit" />
      </form>
      <div className={'term-list--date'}>{name}</div>
      <div className={'term-list--price'}>
        {`￥ ${parseInt(price, 10).toLocaleString()}  >`}
      </div>
    </div>
  );
}

PaymentTerm.propTypes = propTypes;
PaymentTerm.defaultProps = defaultProps;
